import { lazy, ReactElement } from "react";
import robotImg from "../../assets/Robot.png";
import BusinessIcon from "@mui/icons-material/Business";
import SimCardOutlined from "@mui/icons-material/SimCardOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";

// Route views are lazy-loaded so their heavy dependencies (the MUI DataGrid and
// the three Nivo chart packages in particular) are split into separate chunks
// and only downloaded when the user navigates to that route, instead of being
// pulled into the initial page load. They render inside the <Suspense> boundary
// in RightSide.
const Robots = lazy(() =>
  import("../robots").then((m) => ({ default: m.Robots })),
);
const AzureAdSync = lazy(() =>
  import("../organization").then((m) => ({ default: m.AzureAdSync })),
);
const SimCard = lazy(() =>
  import("../sim/SimCard").then((m) => ({ default: m.SimCard })),
);
const Dashboard = lazy(() =>
  import("../dashboard/Dashboard").then((m) => ({ default: m.Dashboard })),
);

// Holds i18n keys rather than translated strings: translating here at module
// scope froze the texts to the language active at import time. Consumers
// (MenuOption, TopAppBar) translate at render time.
export const MenuOptionsConfig: MenuOptionConfig[] = [
  {
    path: "/robots",
    textKey: "adminPanel.robots.title",
    image: robotImg,
    component: <Robots />,
  },
  {
    path: "/organization",
    textKey: "adminPanel.organization.title",
    icon: <BusinessIcon />,
    component: <AzureAdSync />,
  },
  {
    path: "/sim",
    textKey: "adminPanel.sim.title",
    icon: <SimCardOutlined />,
    component: <SimCard />,
  },
  {
    path: "/dashboard",
    textKey: "adminPanel.dashboard.title",
    icon: <AnalyticsOutlinedIcon />,
    component: <Dashboard />,
  },
];

export interface MenuOptionConfig {
  path?: string;
  image?: string;
  icon?: ReactElement;
  textKey: string;
  component?: ReactElement;
}
